export default "<router-outlet name=\"fullWidthOverlay\" id=\"fullWidthOverlay\"></router-outlet>\n"